export enum SampleBackgroundColor {
    None = '',
    Aqua = 'a5e1e1',
    Purple = '792583',
    Pink = 'f192b0',
    Blue = '3abff0'
}